<template>
  <div class="container push-top">
    <loading-indicator v-if="documents === false"></loading-indicator>

    <div class="columns" v-if="documents.length > 0">
      <h2 class="column is-8 is-pulled-left" v-if="!search">{{ $t('proposals.drafts') }}</h2>
      <h2 class="column is-8 is-pulled-left" v-if="search">{{ $t('proposals.search_results') }}</h2>

      <div class="column is-4">
        <div class="search-wrapper">
          <div class="searchbox is-pulled-right">
            <span><i class="icon icon-search"></i></span>
            <input type="search" id="search"  :placeholder="$t('search.placeholder')" v-model="search">
          </div>
        </div>
        <span class="toggle is-pulled-right">
          <a title="Grid Layout" :class="{ 'is-active': showGallery }" @click="showGallery = true"><i class="icon icon-toggle-blocks"></i></a>
          <a title="List Layout" :class="{ 'is-active': !showGallery }" @click="showGallery = false"><i class="icon icon-toggle-list"></i></a>
        </span>
      </div>
    </div>

    <div v-if="documents !== false && documents.length <= 0">
      <div class="columns">
        <h2 class="column is-12" v-if="!search">{{ $t('proposals.drafts') }}</h2>
      </div>
    </div>

    <div v-if="documents && u.where(documents, { status: 'draft' }).length < 1">
      <div class="columns">
        <div class="column is-12">
          <div class="create-new-proposal">
            <a @click="Events.$emit('modalOpen', 'newDocumentModal')" class="button is-primary is-outlined">
              <i class="icon icon-add"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="documents && search">
      <div class="column is-12">
        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && showGallery" class="proposal-cards">
            <document-card :payload="document" :key="document.id" v-for="document in filteredDocuments" v-if="search" @delete="deleteDocument"></document-card>
          </ul>
        </transition>

        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && !showGallery" class="proposal-line-items">
            <document-line-item :payload="document" :key="document.id" v-for="document in filteredDocuments" v-if="search" @delete="deleteDocument"></document-line-item>
          </ul>
        </transition>
      </div>
    </div>

    <div class="columns" v-if="documents && !search">
      <div class="column is-12">
        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && showGallery" class="proposal-cards">
            <document-card :payload="document" :key="document.id" v-for="document in u.where(documents, { status: 'draft' })" @delete="deleteDocument"></document-card>
          </ul>
        </transition>

        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && !showGallery" class="proposal-line-items">
            <document-line-item :payload="document" :key="document.id" v-for="document in u.where(documents, { status: 'draft' })" @delete="deleteDocument"></document-line-item>
          </ul>
        </transition>
      </div>
    </div>

    <hr class="proposals-break" v-if="documents">

    <div class="columns" v-if="documents">
      <div class="column is-12">

        <form class="propsal-filter is-pulled-right" name="">
          <span class="filter-by">{{ $t('filters.filter_by') }} </span>

          <multiselect
            v-model="filterTeamMember"
            :options="filterTeamMemberOptions"
            :placeholder="$t('filters.team_filter_options.everyone')"
            track-by="id"
            label="name"
            :searchable="false"
            :showLabels="false"
          ></multiselect>
          <multiselect
            v-model="filterStatus"
            :options="filterStatusOptions"
            :placeholder="$t('filters.status_filter_options.all_statuses')"
            track-by="value"
            label="label"
            :searchable="false"
            :showLabels="false"
          ></multiselect>
          <multiselect
            v-model="filterDate"
            :options="filterDateOptions"
            :placeholder="$t('filters.date_filter_options.all_time')"
            track-by="value"
            label="label"
            :searchable="false"
            :showLabels="false"
          ></multiselect>
        </form>

        <h2 class="is-pulled-left" v-if="documents">{{ $t('proposals.sent_proposals') }}</h2>
      </div>
    </div>

    <div v-if="documents && sentCount < 1">
      <div class="columns">
        <div class="column is-12">
          <div class="no-proposals-sent">
            <p>Nothing to see here ... :(</p>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-12">
        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && showGallery" class="proposal-cards">
            <document-card :payload="document" :key="document.id" v-for="document in filterByStatus(['sent', 'viewed', 'pending', 'signed', 'expired'])" v-if="sentCount > 0" @delete="deleteDocument"></document-card>
          </ul>
        </transition>

        <transition enter-active-class="animated fadeIn" leave-active-class="hidden">
          <ul v-if="documents && !showGallery" class="proposal-line-items">
            <document-line-item :payload="document" :key="document.id" v-for="document in filterByStatus(['sent', 'viewed', 'pending', 'signed', 'expired'])" v-if="sentCount > 0" @delete="deleteDocument"></document-line-item>
          </ul>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
  import API from 'mixins/api';
  import DocumentCard from './partials/document-card.vue';
  import DocumentLineItem from './partials/document-line-item.vue';

  export default {
    props: ['currentTeam', 'user', 'teams'],
    mixins: [API],
    components: {
      DocumentCard,
      DocumentLineItem,
    },
    data() {
      return {
        Events: window.Events,
        u: window._,
        alertModalActive: false,
        search: '',
        filterTeamMember: null,
        filterTeamMemberOptions: [],
        filterStatus: null,
        filterStatusOptions: [],
        filterDate: null,
        filterDateOptions: [],
        showGallery: true,
        showList: false,
        documents: false,
        draftCount: 0,
        sentCount: 0,
        filteredDocuments: [],
      }
    },
    beforeMount() {
      this.api().fetchTeamDocuments()
        .then(documents => this.documents = documents)
        .then(this.filter);
      this.filterTeamMemberOptions = _.clone(this.currentTeam.users);
      this.filterTeamMemberOptions.unshift({
        name: this.$t('filters.team_filter_options.everyone'),
        value: null
      });
      this.filterStatusOptions = [
        { label: this.$t('filters.status_filter_options.all_statuses'), value: null },
        { label: this.$t('filters.status_filter_options.expired'), value: 'expired' },
        { label: this.$t('filters.status_filter_options.sent'), value: 'sent' },
        { label: this.$t('filters.status_filter_options.viewed'), value: 'viewed' },
        { label: this.$t('filters.status_filter_options.pending'), value: 'pending' },
        { label: this.$t('filters.status_filter_options.signed'), value: 'signed' },
      ];
      this.filterDateOptions = [
        { label: this.$t('filters.date_filter_options.all_time'), value: null },
        { label: this.$t('filters.date_filter_options.past_30_days'), value: 30 },
        { label: this.$t('filters.date_filter_options.past_60_days'), value: 60 },
        { label: this.$t('filters.date_filter_options.past_6_months'), value: 180 },
        { label: this.$t('filters.date_filter_options.past_1_year'), value: 365 },
      ];
    },
    methods: {
      filter() {
        let query = {};
        let startDate;

        this.filteredDocuments = _.clone(this.documents);

        if (this.filterDate && this.filterDate.value !== null) {
          startDate = moment(new Date()).subtract(this.filterDate.value, 'days');
        }

        if (this.filterTeamMember && this.filterTeamMember.value !== null) {
          query.user_id = this.filterTeamMember.id;
        }

        if (this.filterStatus && this.filterStatus.value !== null) {
          query.status = this.filterStatus.value;
        }

        this.filteredDocuments = _.where(this.filteredDocuments, query);

        if (startDate) {
          this.filteredDocuments = _.filter(this.filteredDocuments, function(document) {
            return moment(document.created_at).isAfter(startDate);
          });
        }

        this.draftCount = this.filterByStatus('draft').length;
        this.sentCount = this.filterByStatus('expired').length + this.filterByStatus('sent').length + this.filterByStatus('viewed').length + this.filterByStatus('pending').length + this.filterByStatus('signed').length;
      },
      filterByStatus(status) {
        return _.filter(this.filteredDocuments, function(document) {
          if (typeof status === 'string') {
            return document.status.toLowerCase() === status.toLowerCase();
          } else if (typeof status === 'object') {
            return status.indexOf(document.status.toLowerCase()) > -1;
          }
        });
      },
      deleteDocument(document) {
        this.documents = _.without(this.documents, document);
        this.filter();
      }
    },
    watch: {
      search: function() {
        this.filteredDocuments = _.filter(
          _.clone(this.documents), (document) => {
          return document.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                 (document.contact && document.contact.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                 document.status.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      },
      filterTeamMember() { this.filter(); },
      filterStatus() { this.filter(); },
      filterDate() { this.filter(); },
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .multiselect {
    width: 170px;
    margin-left: 10px;
  }

  .search-wrapper {
    position: relative;
    .searchbox {
      top: -9px;
      right: 67px;
    }
  }

  .no-proposals {
    width: 400px;
    background: $white;
    text-align: center;
    padding: 40px;
    border-radius: 2px;
    display: block;
    margin: 200px auto;
    border: 1px solid lighten($mutedblue, 12%);
    img {
      width: 60px;
      display: block;
      margin: 0 auto 26px;
    }
    h3 {
      font-size: 16px;
      text-transform: uppercase;
      font-weight: 600;
      margin: 0 0 20px;
      letter-spacing: 1px;
    }
    p {
      margin-bottom: 25px;
    }
  }

  .create-new-proposal,
  .no-proposals-sent {
    width: 25%;
    a,
    p {
      margin: 0 26px 20px 0;
      min-height: 226px;
      display: block;
      border-radius: 5px;
      border: 1px solid lighten($mutedblue, 12%);
      text-align: center;
      padding-top: 83px;
      color: lighten($mutedblue, 12%);
      cursor: pointer;
      i {
        font-size: 50px;
        width: 50px;
      }
      &:hover {
        border-color: $green;
        color: $green;
        background: $white;
      }
    }
    p {
      cursor: default;
      padding-top: 96px;
      &:hover {
        border-color: lighten($mutedblue, 12%);
        color: lighten($mutedblue, 12%);
        background: none;
      }
    }
  }

  ul.proposal-cards {
    display: flex;
    flex-wrap: wrap;
  }

  ul.proposal-line-items {
    margin: 20px 0 40px;
  }

  .toggle {
    a {
      margin-left: 15px;
      color: $mutedblue;
      i {
        font-size: 28px;
      }
      &:hover {
        color: darken($mutedblue, 10%);
      }
      &.is-active {
        color: $green;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Documents.vue?7b308a0c